export default "__VITE_ASSET__CGNhxfPc__"